import * as React from "react";
const SvgFolderIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 256, height: 256, viewBox: "0 0 256 256", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  stroke: "none",
  strokeWidth: 0,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  fill: "none",
  fillRule: "nonzero",
  opacity: 1
}, transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)" }, /* @__PURE__ */ React.createElement("path", { d: "M 82.853 26.245 H 51.074 c -3.262 -0.767 -5.535 -3.633 -5.535 -6.988 c 0 -4.29 -3.49 -7.781 -7.78 -7.781 H 7.781 C 3.491 11.476 0 14.966 0 19.256 v 53.142 c 0 3.378 2.748 6.127 6.127 6.127 h 77.746 c 3.378 0 6.127 -2.749 6.127 -6.127 V 33.392 C 90 29.451 86.793 26.245 82.853 26.245 z", style: {
  stroke: "none",
  strokeWidth: 1,
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  fill: "#006c90",
  fillRule: "nonzero",
  opacity: 1
}, transform: " matrix(1 0 0 1 0 0) ", strokeLinecap: "round" })));
export { SvgFolderIcon as ReactComponent };
